import { all } from "redux-saga/effects";
import {
  getUserAvatarWatch,
  getUserProfileWatch,
  logoutUserWatch
} from "../user/sagas";

export default function* rootSaga() {
  yield all([getUserAvatarWatch(), getUserProfileWatch(), logoutUserWatch()]);
}
